const m = {
  // ── Dashboard / liste ──
  'Cloud e Server Dedicati': 'Cloud & Dedicated Servers',
  'Dashboard Cloud e Server Dedicati': 'Cloud & Dedicated Servers dashboard',
  'Server Dedicati': 'Dedicated servers',
  'Home': 'Home',
  'Scopri le nostre offerte': 'Discover our offers',
  'Caricamento…': 'Loading…',
  'Ordinare': 'Order',
  'Ordina': 'Order',
  'Gestire': 'Manage',
  'Gestisci': 'Manage',
  'Nome': 'Name',
  'Nome servizio': 'Service name',
  'Stato': 'Status',
  'Statuto': 'Status',
  'Scadenza': 'Expiry',
  'Tag': 'Tag',
  'Offerta': 'Plan',
  'Hostname': 'Hostname',
  'Sistema operativo': 'Operating system',
  'Configurazione': 'Configuration',
  'Datacenter': 'Datacenter',
  'Server': 'Server',
  'Scade il {d}': 'Expires on {d}',
  '(G-{dm})': '(D-{dm})',
  '(D-{dm})': '(D-{dm})',
  'Distribuzione: {os}': 'Distribution: {os}',

  // ── Stati servizio ──
  'Avviato': 'Running',
  'Fermo': 'Stopped',
  'In attesa': 'Pending',
  'AVVIA': 'RUNNING',

  // ── Piano dinamico (fallback) ──
  'Server dedicato': 'Dedicated server',

  // ── Empty states ──
  'Non hai nessun VPS': 'You have no VPS',
  'Distribuisci server virtuali Cloud in pochi minuti, con root access completo e risorse dedicate.': 'Deploy Cloud virtual servers in minutes, with full root access and dedicated resources.',
  'Ordina un VPS': 'Order a VPS',
  'Non hai nessun server dedicato': 'You have no dedicated server',
  'Infrastruttura Bare Metal ad alte prestazioni interamente dedicata alla tua azienda.': 'High-performance bare metal infrastructure entirely dedicated to your company.',
  'Ordina un server': 'Order a server',
  'Nessuno spazio di archiviazione': 'No storage space',
  'Storage cloud sicuro e scalabile per backup, archivi e oggetti (S3).': 'Secure, scalable cloud storage for backups, archives and objects (S3).',
  'Ordina Storage': 'Order Storage',
  'Non hai nessun NAS Synology': 'You have no Synology NAS',
  'NAS Synology gestiti e ospitati nei nostri datacenter, per un backup e uno storage privato affidabile.': 'Synology NAS managed and hosted in our datacenters, for reliable private backup and storage.',
  'Ordina un NAS': 'Order a NAS',
  'Nessun servizio di Housing': 'No housing service',
  'Ospita i tuoi server nei nostri datacenter con housing e colocation sicuri e ridondati.': 'Host your servers in our datacenters with secure, redundant housing and colocation.',
  'Richiedi Housing': 'Request Housing',

  // ── VPS toolbar ──
  'Storico delle fatture': 'Invoice history',
  'Trasferisci più prodotti su un altro account': 'Transfer multiple products to another account',
  'Mazzo di chiavi': 'Keychain',
  'Ricerca': 'Search',
  'Cancella': 'Clear',
  'Scaricare la lista nel formato CSV': 'Download the list in CSV format',
  'Modifica nella vista elenco': 'Switch to list view',
  'Modifica nella vista scheda': 'Switch to card view',

  // ── Menu riga VPS ──
  'Pannello di controllo': 'Control panel',
  'Modifica l’offerta': 'Change plan',
  'Rinnova': 'Renew',
  'Trasferisci a un altro account': 'Transfer to another account',
  'Termina': 'Terminate',
  'Aggiungi un tag': 'Add a tag',
  'Gestisci i tag': 'Manage tags',

  // ── Tag modal ──
  'Etichetta': 'Label',
  'Rimuovi': 'Remove',
  'Seleziona o crea un tag': 'Select or create a tag',
  'Crea il tag «{name}»': 'Create the tag «{name}»',
  'Crea un tag': 'Create a tag',
  'Nome del tag': 'Tag name',
  'Annullare': 'Cancel',
  'Crea': 'Create',

  // ── Console VNC ──
  'Connessione alla console…': 'Connecting to the console…',
  'VNC non abilitata su questo server.': 'VNC is not enabled on this server.',
  'Console disconnessa.': 'Console disconnected.',
  'Connessione alla console persa.': 'Connection to the console lost.',
  'Autenticazione VNC non riuscita.': 'VNC authentication failed.',
  'Impossibile avviare la console.': 'Unable to start the console.',
  'Connesso': 'Connected',
  'Connessione…': 'Connecting…',
  'Non connesso': 'Not connected',
  'Console — {name}': 'Console — {name}',
  'Chiudi': 'Close',
  'Riprova': 'Retry',
  'Ctrl+Alt+Canc': 'Ctrl+Alt+Del',
  'Riconnetti': 'Reconnect',
  'Schermo intero': 'Full screen',

  // ── Firewall (regole) ──
  'Aprire "tutte le porte" non è consentito: seleziona applicazioni o porte specifiche.': 'Opening "all ports" is not allowed: select applications or specific ports.',
  'Indica inizio e fine dell’intervallo di porte.': 'Enter the start and end of the port range.',
  'Seleziona almeno una porta o un’applicazione.': 'Select at least one port or application.',
  'Per policy non è possibile aprire la porta 25 (SMTP).': 'For policy reasons, port 25 (SMTP) cannot be opened.',
  'Indica l’indirizzo IP sorgente.': 'Enter the source IP address.',
  'Regola modificata.': 'Rule updated.',
  'Regola aggiunta.': 'Rule added.',
  'Operazione firewall non riuscita.': 'Firewall operation failed.',
  'Regola eliminata.': 'Rule deleted.',
  'Eliminazione non riuscita.': 'Deletion failed.',
  'Regola attivata.': 'Rule enabled.',
  'Regola disattivata.': 'Rule disabled.',
  'Operazione non riuscita.': 'Operation failed.',
  'Regole di origine ripristinate.': 'Default rules restored.',
  'Ripristino non riuscito.': 'Restore failed.',
  'Caricamento regole…': 'Loading rules…',
  'Impossibile leggere il firewall.': 'Unable to read the firewall.',
  'Nessuna regola definita per il momento': 'No rules defined yet',
  'Aggiungere una regola': 'Add a rule',
  'Esportare': 'Export',
  'Ripristina le regole di origine': 'Restore default rules',
  'Cercare…': 'Search…',
  'Tipo': 'Type',
  'Porta': 'Port',
  'IP/Ospite': 'IP/Host',
  'Descrizione': 'Description',
  'Tutti': 'All',
  'Tutte': 'All',
  'Attivato': 'Enabled',
  'Disattivato': 'Disabled',
  'Azioni': 'Actions',
  'Modificare': 'Edit',
  'Disattivare': 'Disable',
  'Attivare': 'Enable',
  'Eliminare': 'Delete',
  'Nessun risultato trovato per questi criteri.': 'No results found for these criteria.',
  'Le regole sono applicate in tempo reale sul server. La porta 22 (SSH) è sempre mantenuta consentita; la porta 25 (SMTP) non può essere aperta.': 'The rules are applied in real time on the server. Port 22 (SSH) is always kept allowed; port 25 (SMTP) cannot be opened.',
  'Desidera veramente eliminare questa regola?': 'Do you really want to delete this rule?',
  'Desidera veramente disattivare questa regola?': 'Do you really want to disable this rule?',
  'Attendere…': 'Please wait…',
  'Ripristinare le regole di origine?': 'Restore the default rules?',
  'Tutte le regole personalizzate verranno rimosse e il firewall tornerà alla configurazione predefinita. La porta 22 (SSH) resterà sempre consentita.': 'All custom rules will be removed and the firewall will return to its default configuration. Port 22 (SSH) will always remain allowed.',
  'Ripristina': 'Restore',

  // ── Firewall (aggiungi/modifica regola) ──
  'Porte da aprire': 'Ports to open',
  'Tutte le porte': 'All ports',
  'Per una o più applicazioni': 'For one or more applications',
  'Selezione manuale': 'Manual selection',
  'Applicazione/i selezionata/e : {n}': 'Selected application(s): {n}',
  'CERCARE…': 'SEARCH…',
  'Porte': 'Ports',
  'Protocollo': 'Protocol',
  'Porte separate da una virgola': 'Comma-separated ports',
  'Gamma di porte': 'Port range',
  'di': 'from',
  'a': 'to',
  'Sorgente IP': 'Source IP',
  'IP specifici': 'Specific IPs',
  'IP unico': 'Single IP',
  'In rete': 'Subnet',
  'Gamma di indirizzo IP': 'IP address range',
  'Indirizzo IP': 'IP address',
  'Lunghezza del prefisso/suffisso': 'Prefix/suffix length',
  'Convalidare': 'Confirm',

  // ── Snapshot ──
  'Uno snapshot permette di eseguire il backup dell’intero server su uno spazio dedicato.': 'A snapshot lets you back up the entire server to a dedicated space.',
  'Snapshot utilizzati : 0 / 1': 'Snapshots used: 0 / 1',
  'Nessuno snapshot per il momento': 'No snapshots yet',
  'Hai a disposizione uno snapshot gratuito per eseguire il backup dell’intero server. Provalo!': 'You have one free snapshot available to back up the entire server. Try it!',
  'Crea uno snapshot': 'Create a snapshot',

  // ── Domini associati ──
  'Associare un dominio': 'Associate a domain',
  'Domini associati': 'Associated domains',
  'Domini': 'Domains',
  'Verifica DNS in corso…': 'Checking DNS…',
  'Associazione dominio: funzione in arrivo.': 'Domain association: coming soon.',
  'Sotto-dominio': 'Subdomain',
  'Nessun dominio associato per il momento': 'No associated domain yet',

  // ── Manutenzione ──
  'Manutenzioni programmate': 'Scheduled maintenance',
  'Nessuna manutenzione programmata': 'No scheduled maintenance',
  'Non sono previsti interventi di manutenzione su questa VPS. Eventuali finestre di manutenzione del nodo verranno comunicate via email e mostrate qui.': 'No maintenance is planned for this VPS. Any node maintenance windows will be communicated by email and shown here.',

  // ── Reverse DNS ──
  'Caricamento reverse DNS…': 'Loading reverse DNS…',
  'Nome dell’host (FQDN)': 'Host name (FQDN)',
  'host.esempio.it': 'host.example.com',
  'Registrazione…': 'Registering…',
  'Registrare': 'Register',
  'PTR non applicato sui nameserver.': 'PTR not applied on the nameservers.',
  'Reverse DNS registrato.': 'Reverse DNS registered.',
  'Impossibile registrare il reverse DNS.': 'Unable to register the reverse DNS.',

  // ── Reinstall ──
  'Attenzione! Stai per resettare il tuo server. Durante il processo, tutti i contenuti del volume dedicato al sistema operativo (/dev/sda, /dev/sda1 o /dev/vda) verranno eliminati definitivamente.': 'Warning! You are about to reset your server. During the process, all contents of the volume dedicated to the operating system (/dev/sda, /dev/sda1 or /dev/vda) will be permanently deleted.',
  'Distribuzione / versione': 'Distribution / version',
  'Distribuzione': 'Distribution',
  'Versione': 'Version',
  '{n} — consigliata': '{n} — recommended',
  'Password di root': 'Root password',
  'Almeno 8 caratteri': 'At least 8 characters',
  'La password verrà impostata per l’utente': 'The password will be set for the user',
  'del server reinstallato.': 'of the reinstalled server.',
  'Re-inizializzare': 'Reinitialize',
  'Seleziona una versione.': 'Select a version.',
  'La password di root deve avere almeno 8 caratteri.': 'The root password must be at least 8 characters long.',
  'Reinstallazione non riuscita': 'Reinstallation failed',
  'Desidera veramente reinstallare questo server Cloud?': 'Do you really want to reinstall this Cloud server?',
  'Per sicurezza, inserisca la sua password di accesso *': 'For security, enter your login password *',

  // ── Azioni server ──
  '{label}: richiesta inviata al server.': '{label}: request sent to the server.',
  'Operazione non riuscita': 'Operation failed',
  'Arresto': 'Shutdown',
  'Arrestare il server': 'Shut down the server',
  'È sicuro di voler chiudere questo Cloud?': 'Are you sure you want to shut down this Cloud?',
  'Avvio': 'Start',
  'Avviare il server': 'Start the server',
  'Desideri veramente avviare questo server cloud?': 'Do you really want to start this cloud server?',
  'Riavvio (Classic)': 'Reboot (Classic)',
  'Riavviare il server (Modalità classica)': 'Reboot the server (Classic mode)',
  'La modalità classica consente di riavviare normalmente il tuo server.': 'Classic mode lets you reboot your server normally.',
  'Desideri veramente riavviare questo server cloud?': 'Do you really want to reboot this cloud server?',
  'Riavvio (Safe)': 'Reboot (Safe)',
  'Riavviare il server (Modalità sicura)': 'Reboot the server (Safe mode)',
  'La modalità sicura consente di diagnosticare e risolvere eventuali problemi da un sistema operativo temporaneo.': 'Safe mode lets you diagnose and fix issues from a temporary operating system.',
  'Desideri veramente riavviare questo server cloud in modalità sicura?': 'Do you really want to reboot this cloud server in safe mode?',
  'Reset': 'Reset',
  'Ripristinare il server': 'Reset the server',
  'Desideri veramente ripristinare questo server cloud?': 'Do you really want to reset this cloud server?',
  'Riavviare': 'Reboot',

  // ── Control panel ──
  'Modificare le informazioni': 'Edit information',
  'Rinnovare': 'Renew',
  'Trasferire a un altro account': 'Transfer to another account',
  'Rescindere': 'Terminate',
  'Nome del host : {hostname}': 'Host name: {hostname}',
  'INFORMAZIONI': 'INFORMATION',
  'UTENTI': 'USERS',
  'Traffico': 'Traffic',
  'Banda': 'Bandwidth',
  'Illimitato': 'Unlimited',
  'Posizione': 'Location',
  'Messa in servizio': 'Commissioned on',
  'Configurare il reverse DNS': 'Configure reverse DNS',
  'Utente SSH': 'SSH user',
  'Password root': 'Root password',
  'Azioni rapide': 'Quick actions',
  'Fai evolvere la tua offerta': 'Upgrade your plan',
  'Aprire la console VNC': 'Open the VNC console',
  'Impostare il firewall': 'Set up the firewall',
  'Gestire gli snapshot': 'Manage snapshots',
  'Fessure di manutenzione': 'Maintenance windows',
  'Procedura di avvio': 'Getting started',
  'Per rendere operativo il tuo VPS segui i seguenti passaggi:': 'To get your VPS up and running, follow these steps:',
  'Controlla che la porta SSH sia aperta nel': 'Make sure the SSH port is open in the',
  'firewall': 'firewall',
  'Apri un terminale/console': 'Open a terminal/console',
  'Accedi a SSH con i dati di accesso seguenti': 'Log in to SSH with the following credentials',
  'Connessione SSH': 'SSH connection',
  'Copiato negli appunti.': 'Copied to clipboard.',

  // ── Rinomina VPS ──
  'Cambia dettagli': 'Edit details',
  'Nome visualizzato della VPS nel tuo spazio cliente.': 'Display name of the VPS in your customer area.',
  'Nome della VPS': 'VPS name',
  'Annulla': 'Cancel',
  'Salvataggio…': 'Saving…',
  'Salva': 'Save',
  'Nome aggiornato.': 'Name updated.',
  'Impossibile aggiornare il nome.': 'Unable to update the name.',

  // ── Operazione in corso ──
  'Si prega di attendere, aggiornamento dell’offerta in corso...': 'Please wait, plan upgrade in progress...',
  'Si prega di attendere, reimpostazione del server in corso...': 'Please wait, server reset in progress...',
  'Stiamo applicando la nuova configurazione (CPU/RAM/disco). Il server si riavvia, riprova tra qualche minuto.': 'We are applying the new configuration (CPU/RAM/disk). The server is rebooting, try again in a few minutes.',
  'Riprova tra qualche minuto.': 'Try again in a few minutes.',

  // ── Modificare / trasferire (menu) ──
  'Modificare l’offerta': 'Change the plan',

  // ── Eliminazione (a consumo) ──
  'Stai per eliminare il prodotto': 'You are about to delete the product',
  'L’eliminazione del prodotto': 'Deleting the product',
  'sarà immediata e definitiva.': 'will be immediate and permanent.',
  'Le fatture aperte e fuori forfait': 'Open and out-of-plan invoices',
  'dovranno essere regolate.': 'will have to be settled.',
  'Per convalidare l’eliminazione, inserisci la password di accesso al tuo account.': 'To confirm the deletion, enter your account login password.',
  'Password di accesso': 'Login password',
  'Ho letto questi avvisi': 'I have read these warnings',
  'e desidero comunque procedere con la cancellazione.': 'and still wish to proceed with the deletion.',
  'Prodotto eliminato.': 'Product deleted.',
  'Eliminazione non riuscita': 'Deletion failed',

  // ── Disattivazione (termina) ──
  'Disattivazione': 'Deactivation',
  'Modificare una regola': 'Edit a rule',
  'Disattivazione del tuo prodotto {plan} : {nome}': 'Deactivating your {plan} product: {nome}',
  'Motivo del recesso': 'Reason for cancellation',
  'Verifica Mail': 'Email verification',
  'Password': 'Password',
  'Il prodotto {plan} {nome} è stato disattivato.': 'The product {plan} {nome} has been deactivated.',
  'Nei prossimi minuti, tutti gli amministratori riceveranno una e-mail di conferma.': 'In the next few minutes, all administrators will receive a confirmation email.',
  'Torna al manager': 'Back to the manager',
  'Esprimi la tua opinione': 'Share your opinion',
  'Come giudichi questo prodotto? *': 'How would you rate this product? *',
  'Qual è il motivo del recesso? *': 'What is the reason for cancellation? *',
  'Continua': 'Continue',
  'Verifica il tuo indirizzo e-mail per finalizzare l’eliminazione': 'Verify your email address to finalize the deletion',
  'È stata inviata': 'A',
  'una e-mail di verifica': 'verification email',
  'all’indirizzo': 'has been sent to',
  '. Clicca sul link in essa contenuto per continuare l’eliminazione del tuo prodotto.': '. Click the link it contains to continue deleting your product.',
  'Non hai ricevuto nulla? Controlla la cartella della posta indesiderata o invia di nuovo una e-mail.': 'Received nothing? Check your spam folder or send the email again.',
  'Inviare di nuovo la e-mail': 'Resend the email',
  'Verifica del link in corso…': 'Verifying the link…',
  'Disattiva il tuo prodotto {plan} {nome}.': 'Deactivate your product {plan} {nome}.',
  'Tutti gli hosting e tutti i siti web installati su questo server verranno definitivamente rimossi e non saranno più accessibili.': 'All hosting and all websites installed on this server will be permanently removed and will no longer be accessible.',
  'I dati non saranno recuperabili.': 'The data will not be recoverable.',
  'Inserisci la password:': 'Enter the password:',
  'Password di accesso *': 'Login password *',
  'Conferma la disattivazione': 'Confirm the deactivation',
  'Impossibile inviare la richiesta': 'Unable to send the request',
  'Disattivazione non riuscita': 'Deactivation failed',
  'Link non valido o scaduto': 'Invalid or expired link',

  // ── Motivi di recesso ──
  'Difficile da usare': 'Hard to use',
  'Quali problemi hai riscontrato con il prodotto?': 'What issues did you encounter with the product?',
  'Mancanza di funzionalità': 'Lack of features',
  'Di quali funzionalità hai bisogno?': 'Which features do you need?',
  'Non soddisfa le mie esigenze': 'Does not meet my needs',
  'Quali erano le tue esigenze / i tuoi obiettivi nell’utilizzo del prodotto?': 'What were your needs / goals when using the product?',
  'Passo alla concorrenza': 'Switching to a competitor',
  'Per quale concorrente ci lasci?': 'Which competitor are you leaving us for?',
  'Non sono soddisfatta/o del servizio clienti': 'I am not satisfied with customer service',
  'Qual è stata la tua esperienza con il nostro servizio clienti?': 'What was your experience with our customer service?',
  'Prezzo troppo alto': 'Price too high',
  'Hai optato per un’alternativa più economica?': 'Did you choose a cheaper alternative?',
  'Non ho più bisogno del prodotto': 'I no longer need the product',
  'Cosa potremmo fare per migliorare il prodotto in futuro?': 'What could we do to improve the product in the future?',
  'Altro': 'Other',
  'Hai riscontrato un altro problema?': 'Did you encounter another problem?',

  // ── Upgrade modal ──
  'Passa da VPS Lite al nostro VPS Cloud più performante e dai più forza ai tuoi progetti': 'Move from VPS Lite to our more powerful VPS Cloud and give your projects a boost',
  'Guardati le spalle con gli snapshot': 'Cover your back with snapshots',
  'Metti i tuoi progetti in produzione': 'Put your projects into production',
  'SLA garantito al 99,99%': 'SLA guaranteed at 99.99%',
  'Aggiornare': 'Upgrade',
  'Per più informazioni': 'For more information',

  // ── Dettaglio server dedicato ──
  'Server non trovato.': 'Server not found.',
  'Host name : {hostname}': 'Host name: {hostname}',
  'Archiviazione': 'Storage',
  'Configurazione hardware': 'Hardware configuration',
  'Gestione': 'Management',
  'Questo server dedicato è gestito direttamente dal team NeoFlux. Per interventi su hardware, reinstallazione o configurazione apri una richiesta di assistenza.': 'This dedicated server is managed directly by the NeoFlux team. For hardware, reinstallation or configuration work, open a support request.',
  'Apri una richiesta di assistenza': 'Open a support request',
  'Rinnova il server': 'Renew the server',

  // ── VPS detail (varie) ──
  'VPS non trovata.': 'VPS not found.',
};
export default m;
